import {Role} from "../api-roles/Role";
import {UserPlanningEntry} from "./UserPlanningEntry";
import {UserVacation} from "./UserVacation";


export enum UserGender {
  MALE = "MALE",
  FEMALE = "FEMALE",
  UNDEFINED = "UNDEFINED"
}

export const UserGenderTypeDisplayValues = {
  [UserGender.FEMALE]: 'Femme',
  [UserGender.MALE]: 'Homme',
  [UserGender.UNDEFINED]: 'Non-renseigné'
}

export class User {
  static readonly ANONYMOUS: User = new User('', '', '', []);

  constructor(
    readonly userFirstName: string,
    readonly userImageUrl: string,
    readonly userEmail: string,
    readonly userRoles: string[],
    readonly id?: string,
    readonly dateAdd?: number,
    readonly dateUpd?: number,
    readonly enabled?: boolean,
    readonly userDefaultResidenceIds?: string[],
    readonly userExternalId?: string,
    readonly userLastName?: string,
    readonly userFullName?: string,
    readonly userPhone?: string,
    readonly userColor?: string,
    readonly userRole?: Role,
    readonly userRedirectUrl?: string,
    readonly userGender?: UserGender,
    readonly userBirthdate?: number,
    readonly userBirthCountry?: string,
    readonly userNationality?: string,
    readonly userIsManager?: boolean,
    readonly userVacations?: UserVacation[],
    readonly userWorkHours?: number,
    readonly userWorkUnitType?: string,
    readonly userPlanningEntries?: UserPlanningEntry[],
    readonly userWorkWeekDays?: string[],
    readonly userAvailabilities?: any[]
  ) { }

  public get isAuthenticated(): boolean {
    return !!this.userEmail;
  }

  public hasAnyRole(...roles: string[]): boolean {
    for (let r in roles) {
      if (this.userRoles.includes(r)) {
        return true;
      }
    }
    return false;
  }

  public isAdministrator(): boolean {
    return this.userRoles.includes('Administrateur');
  }

}
